/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
	pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface PageTitleStyles {
	title: InjectableCss;
}


export const pageTitleStyles: PageTitleStyles = {
	title: {
		css: css`
			line-height: 1.5rem;
			font-size: 18px;
			font-weight: 400;
			margin-bottom: 1rem;
			display: block;
		`
	}
}

const styles = pageTitleStyles;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
	<Typography variant="h2" as="h1" data-test-selector="PageTitle" {...styles.title}>
		{translate(fields.overrideTitle || pageTitle)}
	</Typography>
);

const widgetModule: WidgetModule = {
	component: connect(mapStateToProps)(PageTitle),
	definition: {
		group: "Basic",
		icon: "heading",
	},
};

export default widgetModule;
